import React from "react";
import Button from "../Button/Button";
import "./modal.scss";

const Modal = ({ errorCode, message, information, canClose = true ,onClose }) => {
  return (
    <div className="dcrfrom-modal">
      <div className="dcrfrom-modal__content">
        <div className="dcrfrom-modal__header">
          <span className="dcrfrom-modal__title">{message}</span>
          {canClose && (
            <span className="dcrfrom-modal__close" onClick={onClose}>
              ×
            </span>
          )}
        </div>
        <div className="dcrfrom-modal__body">
          <div>{information}</div>
        </div>
        {canClose && (
          <div className="dcrfrom-modal__footer">
            <Button onClick={onClose}>Close</Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
